import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

interface EmailVerifyStepProps {
    target: string;
    setCode: (code: string) => void;
    notify: CallableFunction;
}

export const EmailVerifyStep = ({ target, setCode, notify }: EmailVerifyStepProps) => {
    const __ = (window as any).__ ? (window as any).__ as (text: string, ...args: Array<string | number>) => string : (text: string, ...args: Array<string | number>) => text;

    const maskEmail = (email: string) => {
        const [localPart, domain] = email.split('@');
        const visibleStart = localPart.slice(0, 3);
        const visibleEnd = localPart.slice(-3);
        const maskedLocalPart = `${visibleStart}***${visibleEnd}`;
        return `${maskedLocalPart}@${domain}`;
    };

    return (
        <Box>
            <Typography sx={{ my: 2 }} variant="body2" color="text.secondary" gutterBottom align="center">
                {__('Sprawdź swoją pocztę. Wysłaliśmy 6-cyfrowy kod na adres: %s. Wpisz go poniżej, aby potwierdzić logowanie.', maskEmail(target))}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 1, mb: 2 }}>
                <TextField
                    size="small"
                    label={__('Twój sekretny kod')}
                    margin="normal"
                    id="otp-code"
                    onChange={(e) => setCode(e.target.value)}
                    autoComplete="off"
                    slotProps={{
                        htmlInput: {
                            maxLength: 6,
                            sx: { textAlign: 'center' }
                        },
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 1 }}>
                <Typography m="0" variant="body2" gutterBottom>
                    {__('Wiadomość e-mail nie dotarła?')}
                </Typography>
                <Button size="small" color="secondary" onClick={() => notify()}>{__('Wyślij kod ponownie')}</Button>
            </Box>
        </Box>
    );
};